// Typelizer digest 9d486c902b0cba1bb702654f755110a3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/sales_documents/:sales_document_id/pdf */
  show: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/pdf', params, options),
    method: 'get',
  }),
}
